import { MenuItem } from '@mui/material';
import type { SelectProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DetailSelect } from '~/components/forms/details';
import { resources } from '~/generated/locales';

const SUPPORTED_LOCALES = Object.keys(resources).sort();

interface LanguageSelectProps extends Omit<SelectProps, 'children'> {
  browserDefaultLabel?: string;
}

export const LanguageSelect = ({ browserDefaultLabel, ...props }: LanguageSelectProps) => {
  const { t } = useTranslation();
  const defaultLabel =
    browserDefaultLabel ?? t('pages.user.profile.fields.language.browser_default');

  // Each language is named in itself, so the name carries its own lang (WCAG 3.1.2). The select
  // shows the chosen item's children as its value, so the span covers both places.
  return (
    <DetailSelect displayEmpty {...props}>
      <MenuItem value="">{defaultLabel}</MenuItem>
      {SUPPORTED_LOCALES.map((locale) => (
        <MenuItem key={locale} value={locale}>
          <span lang={locale}>{t('locale.name', { lng: locale })}</span>
        </MenuItem>
      ))}
    </DetailSelect>
  );
};
